import React from "react";
import CreateBookForm from "./forms/CreateBookForm";
import {createBook, changePage, fetch_books} from "../action/books.js";
import {connect} from "react-redux";
import {FaCheckCircle} from "react-icons/fa";
import {Link} from "react-router-dom";

class CreateBookPage extends React.Component{
    state={
        modal: false
    }
    submit = (data) => {
        this.setState({loading: true});
        this.props.createBook(data)
            .then(msg => this.setState({modal: true, loading: false}));
        this.setState({data: data});
    }
    closeModal = () => {
        this.setState({modal:false});
        this.props.history.push("/main");
        window.location.reload();
    }
    nextPage = () => {
        this.setState({modal:false})
        this.props.changePage({currentPageNo: 2})
        this.props.fetch_books();
        this.props.history.push("/main/editBook/"+this.state.data.book_type+"/"+this.state.data.bookId);
        window.location.reload();
    }
    render(){
        return(
            <div>
                {this.state.modal && (
                <div className="successc-modal-container">
                    <div className="successc-modal">
                        <FaCheckCircle  className="icon"/>
                        <h1> Congratulations </h1>
                        <h2> Book Created </h2>
                        <div>
                        <button onClick={this.nextPage} className="insert_contents"
                        >Insert The Contents Into Book</button>
                        <span className="link" onClick={this.closeModal}
                        >Or Go Back To Dashboard</span>
                        </div>
                    </div>
                </div>)}
                <h1 className="content_title">Create Book</h1>
                {this.state.loading && (
                    <div className="loader">
                        <div></div>
                        <h1>Please Wait...</h1>
                    </div>
                    )}
                {this.props.bookId !== undefined && 
                <CreateBookForm submit={this.submit} bookId={this.props.bookId}/>}
            </div>
        );
    };
};


function mapStateToProps (state) {
    return {bookId: state.user.totalBooks} 
}

export default connect(mapStateToProps, {createBook, changePage, fetch_books})(CreateBookPage);